import { useState } from 'react'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../Icon'
import Text from '../../Text'

import {
  getHasListingObjectCellImage,
  getListingObjectCellImageSrc,
} from './RentalPortalListingObjectCell.utils'

import * as styles from './RentalPortalListingObjectCell.module.css'

import RentalPortalIcon from '../../../icons/rental-portal.svg'

function RentalPortalListingObjectCell({ className, photo, qaName, title }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const [failedSrc, setFailedSrc] = useState(null)

  const src = getListingObjectCellImageSrc(photo)

  function handleImageError() {
    setFailedSrc(src)
  }

  return (
    <span
      {...getQaSelector({ value: qaName })}
      className={classNames(styles.RentalPortalListingObjectCell, className)}
    >
      <span className={styles.thumb}>
        {getHasListingObjectCellImage({ failedSrc, src }) ? (
          <img
            alt=''
            className={styles.image}
            src={src}
            onError={handleImageError}
          />
        ) : (
          <IconNG
            Icon={RentalPortalIcon}
            color={ICON_COLOR.SecondaryTextColor50}
            size={ICON_HEIGHT_16}
          />
        )}
      </span>
      <FloatingTooltip content={title} disabled={!overflow}>
        <Text className={styles.title} ref={setContentOverflowRef}>
          {title}
        </Text>
      </FloatingTooltip>
    </span>
  )
}

export default RentalPortalListingObjectCell
